export enum FeedbackPositiveColorToken {
  feedbackColorPositivePure = '#00AF00',
  feedbackColorPositiveLight = '#E7F8E5',
  feedbackColorPositiveMedium = '#1D9616',
  feedbackColorPositiveDark = '#058505',
}

export default FeedbackPositiveColorToken

export type TPositive =
  | 'feedbackColorPositivePure'
  | 'feedbackColorPositiveLight'
  | 'feedbackColorPositiveMedium'
  | 'feedbackColorPositiveDark'
